
import { Component, Vue } from "vue-property-decorator";
import * as echarts from "echarts";
// import { EchartsInfo, Obj } from "@/lib/cockpit/echartsInfo";

// type EChartsOption = echarts.EChartsOption;
// type SeriesOption = echarts.SeriesOption;

@Component({})
export default class ChinaMap extends Vue {
  chinaGeoCoordMap = {
    黑龙江: [127.9688, 45.368],
    内蒙古: [110.3467, 41.4899],
    吉林: [125.8154, 44.2584],
    北京市: [116.4551, 40.2539],
    辽宁: [123.1238, 42.1216],
    河北: [114.4995, 38.1006],
    天津: [117.4219, 39.4189],
    山西: [112.3352, 37.9413],
    陕西: [109.1162, 34.2004],
    甘肃: [103.5901, 36.3043],
    宁夏: [106.3586, 38.1775],
    青海: [101.4038, 36.8207],
    新疆: [87.611053, 43.828171],
    西藏: [91.117212, 29.646922],
    四川: [103.9526, 30.7617],
    重庆: [108.384366, 30.439702],
    山东: [117.1582, 36.8701],
    河南: [113.4668, 34.6234],
    江苏: [118.8062, 31.9208],
    安徽: [117.29, 32.0581],
    湖北: [114.3896, 30.6628],
    浙江: [119.5313, 29.8773],
    福建: [119.4543, 25.9222],
    江西: [116.0046, 28.6633],
    湖南: [113.0823, 28.2568],
    贵州: [106.6992, 26.7682],
    云南: [102.9199, 25.4663],
    广东: [113.12244, 23.009505],
    广西: [108.479, 23.1152],
    海南: [110.3893, 19.8516],
    台湾: [120.702967, 24.123621],
    上海: [121.4648, 31.2891]
  };
  chinaDatas = [
    [
      {
        name: "北京市",
        value: 0
      },
      {
        name: "黑龙江",
        value: 0
      },
      { name: "上海市" }
    ],
    [
      {
        name: "内蒙古",
        value: 0
      }
    ],
    [
      {
        name: "吉林",
        value: 0
      }
    ],
    [
      {
        name: "辽宁",
        value: 0
      }
    ],
    [
      {
        name: "河北",
        value: 0
      }
    ],
    [
      {
        name: "天津",
        value: 0
      }
    ],
    [
      {
        name: "山西",
        value: 0
      }
    ],
    [
      {
        name: "陕西",
        value: 0
      }
    ],
    [
      {
        name: "甘肃",
        value: 0
      }
    ],
    [
      {
        name: "新疆",
        value: 0
      }
    ],
    [
      {
        name: "西藏",
        value: 0
      }
    ],
    [
      {
        name: "台湾",
        value: 0
      }
    ],
    [
      {
        name: "黑龙江",
        value: 0
      }
    ],
    [
      {
        name: "云南",
        value: 0
      }
    ],
    [
      {
        name: "宁夏",
        value: 0
      }
    ],
    [
      {
        name: "青海",
        value: 0
      }
    ],
    [
      {
        name: "四川",
        value: 0
      }
    ],
    [
      {
        name: "重庆",
        value: 0
      }
    ],
    [
      {
        name: "山东",
        value: 0
      }
    ],
    [
      {
        name: "河南",
        value: 0
      }
    ],
    [
      {
        name: "江苏",
        value: 0
      }
    ],
    [
      {
        name: "安徽",
        value: 0
      }
    ],
    [
      {
        name: "湖北",
        value: 0
      }
    ],
    [
      {
        name: "浙江",
        value: 0
      }
    ],
    [
      {
        name: "福建",
        value: 0
      }
    ],
    [
      {
        name: "江西",
        value: 0
      }
    ],
    [
      {
        name: "湖南",
        value: 0
      }
    ],
    [
      {
        name: "贵州",
        value: 0
      }
    ],
    [
      {
        name: "广西",
        value: 0
      }
    ],
    [
      {
        name: "海南",
        value: 0
      }
    ],
    [
      {
        name: "上海",
        value: 0
      }
    ]
  ];
  dataJson = require("@/lib/data/china.json");
  series = [] as object[];
  mounted() {
    window.onresize = () => {
      window.location.reload();
    };
    [["北京市", this.chinaDatas]].forEach((item: any) => {
      this.series.push(
        {
          type: "map",
          map: "china",
          aspectScale: 0.85,
          animation: false,
          silent: true,
          cursor: "default",
          layoutCenter: ["50%", "50%"], //地图位置
          layoutSize: "100%",
          zoom: 1, //当前视角的缩放比例
          roam: false, //是否开启平游或缩放
          scaleLimit: {
            //滚轮缩放的极限控制
            min: 1,
            max: 2
          },
          itemStyle: {
            //   borderColor: "#89ECFF",
            //   borderWidth: 3,
            //   shadowColor: "#3383B5",
            //   shadowBlur: 10,
            // areaColor: {
            //   type: "linear",
            //   x: 1200,
            //   y: 0,
            //   x2: 0,
            //   y2: 0,
            //   colorStops: [
            //     {
            //       offset: 0,
            //       color: "rgba(3,27,78,0.75)" // 0% 处的颜色
            //     },
            //     {
            //       offset: 1,
            //       color: "rgba(58,149,253,0.75)" // 50% 处的颜色
            //     }
            //   ],
            //   global: true // 缺省为 false
            // },
            areaColor: "rgba(0, 167, 255, 0.80)",
            borderColor: "#fff",
            borderWidth: 0.5
          }
        },
        {
          type: "effectScatter",
          coordinateSystem: "geo",
          zlevel: 2,
          rippleEffect: {
            //涟漪特效
            period: 4, //动画时间，值越小速度越快
            brushType: "stroke", //波纹绘制方式 stroke, fill
            scale: 4 //波纹圆环最大限制，值越大波纹越大
          },
          label: {
            show: true,
            position: "right", //显示位置
            offset: [5, 0], //偏移设置
            formatter: function(params: any) {
              //圆环显示文字
              return params.data.name;
            },
            fontSize: 13
          },
          symbol: "circle",
          symbolSize: function(val: any) {
            return 5 + val[2] * 5; //圆环大小
          },
          itemStyle: {
            show: true,
            color: "#33FEFE"
            //   color: "#00eaff"
          },
          data: item[1].map((dataItem: any) => {
            return {
              name: dataItem[0].name,
              value: this.chinaGeoCoordMap[dataItem[0].name].concat([
                dataItem[0].value
              ])
              // visualMap: false
            };
          })
        }
      );
    });

    this.drawLine();
  }
  //换算方法
  nowSize(val: number, initWidth = 1920) {
    //当前视口宽度
    let nowClientWidth = document.documentElement.clientWidth;
    if (nowClientWidth < 1280) nowClientWidth = 1280;
    let nowClientHeight = document.documentElement.clientHeight;
    if (nowClientHeight < 800) nowClientHeight = 800;
    return Math.min(
      val * (nowClientWidth / initWidth),
      val * (nowClientHeight / 1080)
    );
  }
  convertData(data: any[]) {
    const res: any = [];
    for (let i = 0; i < data.length; i++) {
      const dataItem = data[i];
      const fromCoord = this.chinaGeoCoordMap[dataItem[0].name];
      const toCoord = [
        [121.4648, 31.2891],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701],
        [117.1582, 36.8701]
      ]; //被攻击点
      if (fromCoord && toCoord[i]) {
        res.push([
          {
            coord: toCoord[i]
          },
          {
            coord: fromCoord,
            value: dataItem[0].value
            // visualMap: false
          }
        ]);
      }
    }
    return res;
  }
  // 地图
  drawLine() {
    const dom = document.getElementById("chinaMap") as HTMLCanvasElement;
    const myChart = echarts.init(dom);
    echarts.registerMap("china", this.dataJson);
    const option = {
      geo: [
        // 重影
        {
          map: "china",
          zlevel: 0,
          aspectScale: 0.85,
          zoom: 1,
          layoutCenter: ["50%", "50%"],
          layoutSize: "100%",
          roam: false, //是否开启平游或缩放
          silent: true,
          itemStyle: {
            //   borderWidth: 1,
            // //   borderColor: "rgba(58,149,253,0.8)",
            // // shadowColor: "#BDEAFF",
            //   shadowOffsetY: -5,
            // //   shadowBlur: 10,
            //   areaColor: "transparent"

            borderColor: "#B8E9FF", // #c0f3fb
            borderWidth: this.nowSize(2), //1
            // shadowColor: "rgba(0, 167, 255, 0.70)", //#8cd3ef
            // shadowOffsetY: 15, // 10
            // shadowBlur: 12, //120
            areaColor: "rgba(0, 167, 255, 0.8)" //rgba(184, 233, 255, 0)
          },
          regions: [
            {
              name: "南海诸岛",
              cursor: "default",
              itemStyle: {
                areaColor: "rgba(0, 10, 52, 1)",
                borderColor: "rgba(0, 10, 52, 1)",
                opacity: 0,
                label: {
                  show: false,
                  color: "#009cc9"
                }
              },
              label: {
                show: false,
                color: "#FFFFFF",
                fontSize: 12
              }
            }
          ]
        },
        {
          zlevel: -2,
          map: "china",
          aspectScale: 0.85,
          zoom: 1,
          layoutCenter: ["50%", "51.2%"], // 51%
          layoutSize: "100%",
          roam: false, //是否开启平游或缩放
          silent: true,
          itemStyle: {
            //   borderWidth: 0,
            //   borderColor: "#C7F0FD",
            //   shadowColor: "#C7F0FD",
            //   shadowOffsetY: 0,
            //   areaColor: "#C7F0FD"
            //   areaColor: "#C7F0FD"

            // borderWidth: 1,
            // // borderColor:"rgba(17, 149, 216,0.6)",
            // borderColor: "rgba(58,149,253,0.8)",
            // shadowColor: "rgba(172, 122, 255,0.5)",
            // shadowOffsetY: 5,
            // shadowBlur: 15,
            // areaColor: "rgba(5,21,35,0.1)"

            borderWidth: this.nowSize(1),
            // borderColor:"rgba(17, 149, 216,0.6)",
            borderColor: "#25CFFF", //rgba(58,149,253,0.8)
            shadowColor: "rgba(0, 33, 60, 1)", //rgba(172, 122, 255,0.5)
            // shadowOffsetY: 15, // 5
            shadowBlur: 10,
            areaColor: "rgba(0, 167, 255, 0.70)" //rgba(5,21,35,0.1)
          },
          regions: [
            {
              name: "南海诸岛",
              cursor: "default",
              itemStyle: {
                areaColor: "rgba(0, 10, 52, 1)",

                borderColor: "rgba(0, 10, 52, 1)",
                opacity: 0,
                label: {
                  show: false,
                  color: "#009cc9"
                }
              },
              label: {
                show: false,
                color: "#FFFFFF",
                fontSize: 12
              }
            }
          ]
        },
        {
          zlevel: -3,
          map: "china",
          aspectScale: 0.85,
          zoom: 1,
          layoutCenter: ["50%", "52.6%"], //52%
          layoutSize: "100%",
          roam: false, //是否开启平游或缩放
          silent: true,
          itemStyle: {
            //   borderWidth: 1,
            //   borderColor: "#4C81A0",
            //   shadowColor: "#13527F",
            //   shadowOffsetY: 5,
            //   shadowBlur: 15,
            //   areaColor: "#124A72"
            //   areaColor: "#124A72"

            // borderWidth: 1,
            // // borderColor: "rgba(57, 132, 188,0.4)",
            // borderColor: "rgba(58,149,253,0.6)",
            // shadowColor: "rgba(14, 77, 152, 0.70)",
            // shadowOffsetY: 5,
            // shadowBlur: 15,
            // areaColor: "transpercent"

            borderWidth: this.nowSize(1), // 1
            // borderColor: "rgba(57, 132, 188,0.4)",
            // borderColor: "rgba(58,149,253,0.6)", //
            shadowColor: "rgba(0, 33, 60, 1)", //rgba(14, 77, 152, 0.70)
            // shadowOffsetY: 30, // 5
            shadowBlur: 15,
            opacity: 0.3,
            areaColor: "rgba(0, 167, 255, 0.70)" //transpercent
          },
          regions: [
            {
              name: "南海诸岛",
              cursor: "default",
              itemStyle: {
                areaColor: "rgba(0, 10, 52, 1)",
                borderColor: "rgba(0, 10, 52, 1)",
                opacity: 0,
                label: {
                  show: false,
                  color: "#009cc9"
                }
              },
              label: {
                show: false,
                color: "#FFFFFF",
                fontSize: 12
              }
            }
          ]
        }
        // {
        //   map: "china",
        //   zlevel: -4,
        //   aspectScale: 0.85,
        //   zoom: 1,
        //   layoutCenter: ["50%", "53%"],
        //   layoutSize: "100%",
        //   roam: false, //是否开启平游或缩放
        //   silent: true,
        //   itemStyle: {
        //     //   borderWidth: 1,
        //     //   borderColor: "#4C81A0",
        //     //   shadowColor: "#0A4670",
        //     //   shadowOffsetY: 12,
        //     //   shadowBlur: 10,
        //     //   areaColor: "#124A72"
        //     //   areaColor: "#124A72"

        //     borderWidth: 1,
        //     // borderColor: "rgba(11, 43, 97,0.8)",
        //     borderColor: "rgba(58,149,253,0.4)",
        //     shadowColor: "rgba(0, 33, 60, 1)",
        //     shadowOffsetY: 15,
        //     shadowBlur: 10,
        //     areaColor: "transpercent"
        //   },
        //   regions: [
        //     {
        //       name: "南海诸岛",
        //       cursor: "default",
        //       itemStyle: {
        //         areaColor: "rgba(0, 10, 52, 1)",

        //         borderColor: "rgba(0, 10, 52, 1)",
        //         opacity: 0,
        //         label: {
        //           show: false,
        //           color: "#009cc9"
        //         }
        //       },
        //       label: {
        //         show: false,
        //         color: "#FFFFFF",
        //         fontSize: 12
        //       }
        //     }
        //   ]
        // }
        // {
        //   zlevel: -5,
        //   map: "china",
        //   aspectScale: 0.85,
        //   zoom: 1,
        //   layoutCenter: ["50%", "54%"],
        //   layoutSize: "100%",
        // //   roam: false,
        //   silent: true,
        //   itemStyle: {
        //     //   borderWidth: 0,
        //     //   borderColor: "rgba(58,149,253,0.4)",
        //     //   shadowColor: "#04253F",rgba(14, 77, 152, 0.70)
        //     //   shadowOffsetY: 15,
        //     //   shadowBlur: 5,
        //     //   areaColor: "transpercent"

        //         borderWidth: 5,
        //         borderColor: "rgba(5,9,57,0.8)",
        //         shadowColor: "rgba(14, 77, 152, 0.70)",
        //         // shadowColor: "rgba(29, 111, 165,0.8)",
        //         shadowOffsetY: 15,
        //         shadowBlur: 10,
        //       areaColor: "rgba(5,21,35,0.1)"
        //   },
        //   regions: [
        //   {
        //     name: "南海诸岛",
        //     cursor: "default",
        //     itemStyle: {
        //       areaColor: "rgba(0, 10, 52, 1)",
        //       borderColor: "rgba(0, 10, 52, 1)",
        //         opacity: 0,
        //         label: {
        //           show: false,
        //           color: "#009cc9"
        //         }
        //     },
        //     label: {
        //       show: false,
        //       color: "#FFFFFF",
        //       fontSize: 12
        //     }
        //   }
        // ]
        // },
      ],
      series: this.series
    };
    myChart.setOption(option);
  }
}
